import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAtomValue } from "jotai";

import { getErrorMessage } from "../../../utils/GeneralUtils";
import SharedViewAPI from "../../../api/api/SharedScreenAPI";
import { newToastEvent } from "../../../utils/ToastUtil";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";

interface Props {
  sharedIds: string[];
  moduleAPIName: string;
  onSuccess?: () => void;
}

// Handles unsharing (bulk) pages, views AND record pages.
export default function useUnshareScreens() {
  const client = useQueryClient();
  const tenantID = useAtomValue(tenantIDAtom);

  const unshareScreen = useMutation({
    mutationFn: ({ sharedIds, moduleAPIName }: Props) => {
      return SharedViewAPI.unshareScreens(sharedIds, moduleAPIName).then(
        (data) => data.data.data
      );
    },
    onSuccess: (data, { sharedIds, moduleAPIName }) => {
      client.setQueriesData(
        { queryKey: [tenantID, "records", moduleAPIName] },
        (prev: any) => {
          if (!prev?.records) return;

          const newRecords = prev.records.filter(
            (r: any, i: number) => !sharedIds.includes(r.id)
          );

          return {
            ...prev,
            records: newRecords,
          };
        }
      );

      newToastEvent("success", "Successfully deleted records");
    },
    onError: (e) => {
      newToastEvent("error", getErrorMessage(e));
    },
    onSettled: (_, e, { onSuccess }) => onSuccess && onSuccess(),
  });

  return {
    unshareScreen: unshareScreen.mutate,
    loading: unshareScreen.isPending,
  };
}
